// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5355":"25a37585fe1326e7","8224":"9cc10b0127bf42d3"}[chunkId] + ".js";
};